// extracted by mini-css-extract-plugin
export default {"card":"WidgetPreview_card__Hcn0K"};